import { Axios } from 'axios';
import { API_ECS_BASE_URL_BY_ENV_TO_BASE_URL_MAP } from './http-client.constants.js';
import authInterceptor from './authInterceptor.js';
import feCommonDataHolder from '../fe-common.initialize.js';

class HttpClient extends Axios {
    constructor(config){
        const baseURL = config.baseURlType ? API_ECS_BASE_URL_BY_ENV_TO_BASE_URL_MAP[config.baseURlType][feCommonDataHolder.getEnv()] : config.baseURL;
        super({
            ...config,
            baseURL
        }), this.entity_id_vs_auth_code = {};
        if (config.withQuinceCustomerAuthorization) {
            this.interceptors.request.use(authInterceptor);
        }
    }
}

export { HttpClient as default };
//# sourceMappingURL=http-client.js.map
